import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import LINKS from 'desktop/constants/navigation';
import Link from 'shared/components/Link/Link';
import { getUserThing } from 'shared/helpers/users';
import s from './ProfileButton.css';

class ProfileButton extends React.Component {
  static propTypes = {
    user: PropTypes.shape().isRequired,
    logout: PropTypes.func.isRequired,
  };
  static defaultProps = {
    logout: () => {},
  };
  render() {
    const { user } = this.props;
    const buttonTitle = getUserThing(user);
    const avatar = user.avatar;
    const avatarImg = avatar && avatar.replace('http:', 'https:');
    return (
      <div className={s.root}>
        <Link className={s.link} to="/my/">
          {avatarImg &&
            <div className={s.avatarContainer}>
              <img alt="" src={avatarImg} className={s.avatar} />
            </div>}
          <div title={buttonTitle} className={s.btnTitle}>
            {buttonTitle}
          </div>
        </Link>
        <div className={s.dropdown}>
          <div className={s.dropdownList}>
            {LINKS.PROFILE.map(link =>
              <Link key={link.route} className={s.dropdownLink} to={link.route}>
                <FormattedMessage id={link.title} />
              </Link>,
            )}
            <Link onClick={this.props.logout} className={cx(s.dropdownLink, s.logout)} to="/login/">
              <FormattedMessage id="Выйти" />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ProfileButton);



// WEBPACK FOOTER //
// ./src/desktop/components/Navigation/ProfileButton/ProfileButton.js